var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.matched.length==3),expression:"$route.matched.length==3"}]}),_c('PageHeaderLayout',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.matched.length==2),expression:"$route.matched.length==2"}]},[_c('BusinessList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }